// src/pages/Login.js
import React, { useState } from 'react';
import './Login.css';
import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from 'firebase/auth';
import { auth } from '../firebase/firebaseConfig';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        formData.email,
        formData.password
      );

      const user = userCredential.user;
      alert('Login successful!');

      if (user.email === 'morinea@usiu.ac.ke') {
        navigate('/admin-dashboard');
      } else {
        navigate('/client-dashboard');
      }
    } catch (error) {
      console.error('Login error:', error.message);
      alert('Login failed: ' + error.message);
    }
  };

  const handleForgotPassword = async () => {
    if (!formData.email) {
      alert('Please enter your email to receive reset instructions.');
      return;
    }

    try {
      await sendPasswordResetEmail(auth, formData.email);
      alert(`Password reset link sent to ${formData.email}. Check your inbox.`);
    } catch (error) {
      console.error('Password reset error:', error.message);
      alert('Failed to send reset email: ' + error.message);
    }
  };

  const backgroundImage =
    'https://static.vecteezy.com/system/resources/thumbnails/024/494/104/small_2x/abstract-light-background-blue-background-with-waves-free-photo.jpg';

  const leftImage =
    'https://www.shutterstock.com/shutterstock/photos/1842408310/display_1500/stock-vector-lost-and-found-service-concept-with-cartoon-characters-loosing-baggage-while-airline-flight-1842408310.jpg';

  const rightImage =
    'https://img.freepik.com/premium-vector/cartoon-young-man-returning-lost-wallet-lost-found-service_341509-1088.jpg?w=360';

  return (
    <div
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'row',
        position: 'relative',
        padding: '2rem',
      }}
    >
      <style>{`
        @media (max-width: 768px) {
          .login-layout {
            flex-direction: column !important;
          }

          .side-image {
            display: none !important;
          }

          .login-form {
            width: 100% !important;
          }
        }
      `}</style>

      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          width: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.6)',
          zIndex: 1,
        }}
      />

      <div
        className="login-layout"
        style={{
          display: 'flex',
          flex: 1,
          zIndex: 2,
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <div
          className="side-image"
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1rem',
          }}
        >
          <img
            src={leftImage}
            alt="Lost item"
            style={{
              width: '220px',
              height: 'auto',
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
            }}
          />
        </div>

        <form
          className="login-form"
          onSubmit={handleSubmit}
          style={{
            flex: 2,
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            padding: '2rem',
            borderRadius: '12px',
            boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
            width: '100%',
            maxWidth: '400px',
            margin: '1rem',
          }}
        >
          <h2>Login</h2>
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <button type="submit">Log In</button>

          <div className="forgot-password" style={{ marginTop: '1rem' }}>
            <button
              type="button"
              className="forgot-link"
              onClick={handleForgotPassword}
              style={{
                background: 'none',
                border: 'none',
                color: '#1B3B6F',
                textDecoration: 'underline',
                cursor: 'pointer',
                padding: 0,
              }}
            >
              Forgot Password?
            </button>
          </div>
        </form>

        <div
          className="side-image"
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1rem',
          }}
        >
          <img
            src={rightImage}
            alt="Found item"
            style={{
              width: '220px',
              height: 'auto',
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Login;
